export default __webpack_public_path__ + "static/media/checked-icon-gray.93c5d809.svg";